import NetworkError from "../../components/NetworkError";
import Preloader from "../../components/Preloader";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { config } from "../../constants/config";
import { useEffect } from "react";
import { Asterisk, CreditCard, Envelope, Person, Phone } from "react-bootstrap-icons";
import UserContext from "../../contexts/UserContext";
import { textes } from "../../constants/textes";



export default function RevendeurInfos({ code }) {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [editedstate, setEditedstate] = useState(false);
    const [editeduserstate, setEditeduserstate] = useState(false);
    const [error, setError] = useState(false);

    const [login, setLogin] = useState("");
    const [etat, setEtat] = useState("");
    const [datecrea, setDatecrea] = useState("");
    const [codeuser, setCodeUser] = useState('');
    const [codecompte, setCodecompte] = useState('');
    const [nom, setNom] = useState("");
    const [cni, setCni] = useState("");
    const [passeport, setpasseport] = useState("");
    const [email, setEmail] = useState("");
    const [tel, setTel] = useState("");
    const [prenom, setPrenom] = useState("");
    const [solde, setsolde] = useState("");
    const [retenu, setretenu] = useState("");
    const [fa, setfa] = useState(false);
    const [pub, setpub] = useState(false);
    const [vpn, setvpn] = useState(false);
    const [logo, setLogo] = useState('');
    const [logoprev, setLogoprev] = useState('/assets/imgs/no-image.png');
    const [rectocni, setrectocni] = useState('');
    const [rectocniprev, setrectocniprev] = useState('/assets/imgs/no-image.png');
    const [versocni, setversocni] = useState('');
    const [versocniprev, setversocniprev] = useState('/assets/imgs/no-image.png');
    const [imgpassport, setimgpassport] = useState('');
    const [imgpassportprev, setimgpassportprev] = useState('/assets/imgs/no-image.png');


    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        setLogo(file)
        TransformeLogo(file);
        // console.log("recto prev", rectoprev)
    };

    const TransformeLogo = (file) => {
        const reader = new FileReader();

        if (file) {
            reader.readAsDataURL(file);
            reader.onloadend = () => {
                setLogoprev(reader.result);
            };
        } else {
            setLogoprev("/assets/imgs/blank.png");
        }
    };

    const handleRectoChange = (e) => {
        const file = e.target.files[0];
        setrectocni(file)
        TransformeRecto(file);
        // console.log("recto prev", rectoprev)
    };

    const TransformeRecto = (file) => {
        const reader = new FileReader();

        if (file) {
            reader.readAsDataURL(file);
            reader.onloadend = () => {
                setrectocniprev(reader.result);
            };
        } else {
            setrectocniprev("/assets/imgs/no-image.png");
        }
    };

    const handleVersoChange = (e) => {
        const file = e.target.files[0];
        setversocni(file)
        TransformeVerso(file);
        // console.log("recto prev", rectoprev)
    };

    const TransformeVerso = (file) => {
        const reader = new FileReader();

        if (file) {
            reader.readAsDataURL(file);
            reader.onloadend = () => {
                setversocniprev(reader.result);
            };
        } else {
            setversocniprev("/assets/imgs/no-image.png");
        }
    };

    const handlePassportChange = (e) => {
        const file = e.target.files[0];
        setimgpassport(file)
        TransformePassport(file);
        // console.log("recto prev", rectoprev)
    };

    const TransformePassport = (file) => {
        const reader = new FileReader();

        if (file) {
            reader.readAsDataURL(file);
            reader.onloadend = () => {
                setimgpassportprev(reader.result);
            };
        } else {
            setimgpassportprev("/assets/imgs/no-image.png");
        }
    };


    const getCompte = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/users/${code}?type=revendeur`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let body = data?.body?.data[0];

                        setCodecompte(body?.code !== null ? body?.code : "");
                        setCodeUser(body?.codeutilisateur !== null ? body?.codeutilisateur : "");
                        setLogin(body?.login !== null ? body?.login : "");
                        setEtat(body?.etat);
                        setCni(body?.numcni !== null ? body?.numcni : "");
                        setpasseport(body?.numpasseport !== null ? body?.numpasseport : "");
                        setsolde(body?.solde !== null ? body?.solde : "");
                        setretenu(body?.retenu !== null ? Number.parseFloat(body?.retenu) : 0);
                        setfa(body?.fa !== null ? body?.fa : false);
                        setpub(body?.pub !== null ? body?.pub : false);
                        setvpn(body?.vpn !== null ? body?.vpn : false);
                        setNom(body?.nom !== null ? body?.nom : "");
                        setPrenom(body?.prenom !== null ? body?.prenom : "");
                        setTel(body?.numtel !== null ? body?.numtel : "");
                        setEmail(body?.email !== null ? body?.email : "");
                        setLogoprev(body?.photo !== null ? body?.photo : "/assets/imgs/blank.png")
                        setrectocniprev(body?.rectocni !== null ? body?.rectocni : "/assets/imgs/no-image.png")
                        setversocniprev(body?.versocni !== null ? body?.versocni : "/assets/imgs/no-image.png")
                        setimgpassportprev(body?.imgpasseport !== null ? body?.imgpasseport : "/assets/imgs/no-image.png")
                        setDatecrea(body?.datecrea !== null ? body?.datecrea.slice(0, 19).replace("T", " à ") : "");

                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }

        })
            .catch((err) => {
                // console.log("error", err);
                setError(true);
                setLoading(false);
            });
    }


    // comportements
    useEffect(() => {
        getCompte();
    }, []);

    const handleSubmitEditUser = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: 'Modifier',
            message: 'Etes-vous sûr de vouloir modifier les informations de ce revendeur?',
            buttons: [
                {
                    label: "Confirm",
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setFetching(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        if (retenu) urlencoded.append("retenu", retenu);
                        // urlencoded.append("psuper", user?.isFullAction ? true : false);

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        // console.log("data send", urlencoded)

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/dealeraccounts/${code}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage("Opération réussie.");
                                setEditeduserstate(false);
                                getCompte();
                                setFetching(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setFetching(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setFetching(false);
                            }

                        })
                            .catch((err) => {
                                // console.log("error", err);
                                // setError(true);
                                showErrorMessage(config.texts.unavailblemsg);
                                setFetching(false);
                            });
                    }
                },
                {
                    label: "Cancel",
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }



    // affichages
    return (
        <>
            {loading && <Preloader />}
            {!loading && error && <NetworkError />}
            {!loading && !error && <div className="row">
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <button onClick={() => navigate(-1)} data-toggle="tooltip" title="Quit" data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                        <i className="fa fa-reply"></i> <span>Go Back</span>
                                    </button>
                                    {/* {!editedstate && !editeduserstate && <button onClick={() => setEditedstate(true)}
                                        title="Update account username"
                                        className="btn-shadow ml-3 btn btn-success btn-sm float-right">
                                        <i className="fa fa-edit mr-1"></i> <span>Update username</span>
                                    </button>} */}
                                    {!editeduserstate && !editedstate && <button onClick={() => setEditeduserstate(true)}
                                        title="Update user informations"
                                        className="btn-shadow ml-3 btn btn-success btn-sm float-right">
                                        <i className="fa fa-edit mr-1"></i> <span>Modifier</span>
                                    </button>}
                                    <h6 className="m-0 ">Informations du revendeur</h6>
                                </div>
                                <div className="card-body">
                                    <form style={{ width: "100%" }} onSubmit={handleSubmitEditUser}>
                                        <div className="row">
                                            <div className="col-md-4 mb-3">
                                                <div className="row">
                                                    {editeduserstate && <div className="col-md-12 mb-2">
                                                        <label htmlFor="logo" className="form-label">Picture</label>
                                                        <input className="form-control" type="file" id="logo" onChange={handleLogoChange} />
                                                    </div>}
                                                    <div className="col-md-12 mb-1">
                                                        <img alt="" src={logoprev} className="rounded" style={{ width: "100%" }} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-8 mb-3">
                                                <div className="row">
                                                    <div className="col-md-12 mb-2 mt-3">
                                                        <h4>Informations transactions</h4>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="solde" className="mb-1">Solde</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="solde">
                                                                <Person />
                                                            </span>
                                                            <input type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                value={solde}
                                                                onChange={(e) => setsolde(e.target.value)}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="retenu" className="mb-1">Retenue à chaque retrait (en %)</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="retenu">
                                                                <Person />
                                                            </span>
                                                            <input type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                value={retenu}
                                                                onChange={(e) => setretenu(e.target.value)}
                                                                disabled={editeduserstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-2 mt-3">
                                                        <h4>Informations personnelles</h4>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="nom" className="mb-1">Noms</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="nom">
                                                                <Person />
                                                            </span>
                                                            <input type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                value={nom}
                                                                onChange={(e) => setNom(e.target.value)}
                                                                disabled={editeduserstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="prenom" className="mb-1">Prénoms</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="prenom">
                                                                <Person />
                                                            </span>
                                                            <input type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                value={prenom}
                                                                onChange={(e) => setPrenom(e.target.value)}
                                                                disabled={editeduserstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="cni" className="mb-1">Numéro carte nationale d'identité</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="cni">
                                                                <CreditCard />
                                                            </span>
                                                            <input type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                value={cni}
                                                                onChange={(e) => setCni(e.target.value)}
                                                                disabled={editeduserstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="passeport" className="mb-1">Numéro passeport</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="passeport">
                                                                <CreditCard />
                                                            </span>
                                                            <input type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                value={passeport}
                                                                onChange={(e) => setpasseport(e.target.value)}
                                                                disabled={editeduserstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="email" className="mb-1">Adresse Email</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="email">
                                                                <Envelope />
                                                            </span>
                                                            <input type="email"
                                                                className="form-control"
                                                                placeholder=""
                                                                value={email}
                                                                onChange={(e) => setEmail(e.target.value)}
                                                                disabled={editeduserstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="tel1" className="mb-1">Numéro de téléphone</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="tel1">
                                                                <Phone />
                                                            </span>
                                                            <input type="tel"
                                                                className="form-control"
                                                                placeholder={editeduserstate ? "" : "EX:690000000"}
                                                                value={tel}
                                                                onChange={(e) => setTel(e.target.value)}
                                                                disabled={editeduserstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-3">
                                                        <div className="form-check">
                                                            <input type="checkbox" id="fa"
                                                                className="form-check-input"
                                                                checked={fa}
                                                                onChange={() => { }}
                                                            />
                                                            <label htmlFor="fa" className="mb-1 form-check-label">Fourniture d'accès internet</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-3">
                                                        <div className="form-check">
                                                            <input type="checkbox" id="pub"
                                                                className="form-check-input"
                                                                checked={pub}
                                                                onChange={() => { }}
                                                            />
                                                            <label htmlFor="pub" className="mb-1 form-check-label">Publicité</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-3">
                                                        <div className="form-check">
                                                            <input type="checkbox" id="vpn"
                                                                className="form-check-input"
                                                                checked={vpn}
                                                                onChange={() => { }}
                                                            />
                                                            <label htmlFor="vpn" className="mb-1 form-check-label">Accès VPN</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <div className="row">
                                                            {editeduserstate && <div className="col-md-12 mb-2">
                                                                <label htmlFor="rectocni" className="form-label">Carte d'identité recto</label>
                                                                <input className="form-control" type="file" id="rectocni" onChange={handleRectoChange} />
                                                            </div>}
                                                            <div className="col-md-12 mb-1">
                                                                <h6 >Carte d'identité recto</h6>
                                                                <img alt="" src={rectocniprev} className="rounded" style={{ width: "100%" }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <div className="row">
                                                            {editeduserstate && <div className="col-md-12 mb-2">
                                                                <label htmlFor="versocni" className="form-label">Carte d'identité verso</label>
                                                                <input className="form-control" type="file" id="versocni" onChange={handleVersoChange} />
                                                            </div>}
                                                            <div className="col-md-12 mb-1">
                                                                <h6 >Carte d'identité verso</h6>
                                                                <img alt="" src={versocniprev} className="rounded" style={{ width: "100%" }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <div className="row">
                                                            {editeduserstate && <div className="col-md-12 mb-2">
                                                                <label htmlFor="imgpassport" className="form-label">Image Passeport</label>
                                                                <input className="form-control" type="file" id="imgpassport" onChange={handlePassportChange} />
                                                            </div>}
                                                            <div className="col-md-12 mb-1">
                                                                <h6 >Image Passeport</h6>
                                                                <img alt="" src={imgpassportprev} className="rounded" style={{ width: "100%" }} />
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            {editeduserstate && <div className="col-md-12 mt-2">
                                                <button type="submit"
                                                    title="Mettre les informations à jour"
                                                    className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                // disabled={names && statusinput["value"] ? false : true}
                                                >
                                                    <i className="fa fa-check mr-2"></i>
                                                    <span>Mettre à jour</span> {fetching && <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />}
                                                </button>
                                                <button onClick={() => setEditeduserstate(false)}
                                                    title="Annuler l'operation"
                                                    className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                                    <i className="fa fa-reply mr-1"></i> <span>Annuler</span>
                                                </button>
                                            </div>}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ToastContainer />
                </div>
            </div>}
        </>
    )
}